import './src/ui/layout.css';

// Components
import { Thumbnails } from './src/ui/thumbnails.js';
import { Viewer } from './src/ui/viewer.js';
import { Toolbar } from './src/ui/toolbar.js';
import { ActionsPanel } from './src/ui/actionsPanel.js';

// Logic
import { appStore } from './src/state/store.js';
import { PDFEngine } from './src/pdf/pdfEngine.js';
import { PDFRenderer } from './src/pdf/pdfRenderer.js';

// PDF.js Worker Configuration
import * as pdfjsLib from 'pdfjs-dist';
import pdfWorker from 'pdfjs-dist/build/pdf.worker.mjs?url';
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

// Initialize Components
const thumbnails = new Thumbnails('thumbnails-list');
const viewer = new Viewer('viewer-container');
const toolbar = new Toolbar();
const actionsPanel = new ActionsPanel();

// Global Logic
let docCounter = 0;

async function handleFileSelect(file, mode = 'OPEN') {
    if (!file || file.type !== 'application/pdf') return;

    try {
        const docId = `doc_${++docCounter}`;

        // 1. Read file
        const buffer = await file.arrayBuffer();

        // 2. Load into Engine (Worker)
        // We pass a copy/clone? Or just the buffer and it gets transferred.
        // Because we need it for Renderer too, we MUST clone or read twice if transferring.
        // PDFEngine transfers it.
        // So we need another copy for Renderer.
        const bufferForRenderer = buffer.slice(0); // Copy

        console.log('Loading doc into Engine...');
        const { pageCount } = await PDFEngine.loadDocument(docId, new Blob([buffer])); // Pass Blob to Engine wrapper?
        // Wait, Engine wrapper takes File/Blob and calls arrayBuffer().
        // If I pass Blob, it stays here?
        // My `PDFEngine.loadDocument` implementation:
        // `async loadDocument(docId, file) { const buffer = await file.arrayBuffer(); ... }`
        // So I should pass the file (or a blob) to Engine.
        // And I should use the buffer for Renderer.

        // Proper flow:
        // Engine reads file -> buffer. Transfers buffer to worker.
        // Renderer reads file -> buffer. (Engine already transferred its copy? No, file.arrayBuffer() creates new buffer).
        // File / Blob is immutable source. calling arrayBuffer() on it multiple times creates new buffers.

        await PDFEngine.loadDocument(docId, file);

        console.log('Loading doc into Renderer...');
        await PDFRenderer.loadDocument(docId, bufferForRenderer);

        // 3. Update Store
        appStore.addDocument(docId, pageCount, file.name);

        if (mode === 'OPEN') {
            appStore.initPagesFromDoc(docId, pageCount);
            // Enable buttons
            document.getElementById('btn-import-pdf').disabled = false;
        } else {
            appStore.appendPagesFromDoc(docId, pageCount);
        }

        console.log('Document loaded successfully');

    } catch (err) {
        console.error('Error loading PDF', err);
        alert('Error loading PDF: ' + err.message);
    }
}

// Event Listeners
document.getElementById('btn-open-pdf').addEventListener('click', () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'application/pdf';
    input.onchange = (e) => handleFileSelect(e.target.files[0], 'OPEN');
    input.click();
});

document.getElementById('btn-import-pdf').addEventListener('click', () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'application/pdf';
    input.onchange = (e) => handleFileSelect(e.target.files[0], 'IMPORT');
    input.click();
});

// Drag and drop file on window
document.addEventListener('dragover', (e) => e.preventDefault());
document.addEventListener('drop', (e) => {
    e.preventDefault();
    if (e.dataTransfer.files.length > 0) {
        // If we have pages, treat as import? Or ask?
        // For simplicity: If pages > 0, import. Else Open.
        const mode = appStore.state.pages.length > 0 ? 'IMPORT' : 'OPEN';
        handleFileSelect(e.dataTransfer.files[0], mode);
    }
});

console.log('PDF Editor Ready');
